export enum RentalApplicationErrorScope {
  SingleField = 'singleField',
}
